const LAST_USED_AGENT_KEY = 'lastUsedAgent';
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

interface LastUsedAgent {
  agentId: string;
  timestamp: number;
}

export function saveLastUsedAgent(agentId: string): void {
  const data: LastUsedAgent = {
    agentId,
    timestamp: Date.now()
  };
  
  try {
    localStorage.setItem(LAST_USED_AGENT_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn('Could not save last used agent to localStorage:', error);
  }
}

export function getLastUsedAgent(): string | null {
  try {
    const stored = localStorage.getItem(LAST_USED_AGENT_KEY);
    if (!stored) return null;
    
    const data: LastUsedAgent = JSON.parse(stored);
    const isRecent = (Date.now() - data.timestamp) < SEVEN_DAYS_MS;
    
    if (!isRecent) {
      // Remove expired entry
      localStorage.removeItem(LAST_USED_AGENT_KEY);
      return null;
    }
    
    return data.agentId;
  } catch (error) {
    console.warn('Could not retrieve last used agent from localStorage:', error);
    return null;
  }
}

export function clearLastUsedAgent(): void {
  try {
    localStorage.removeItem(LAST_USED_AGENT_KEY);
  } catch (error) {
    console.warn('Could not clear last used agent from localStorage:', error);
  }
}